import React from 'react'
import Auth from '../../Auth'
import FormPage from '../FormPage'
import { Img } from "react-image";
import { Helmet } from "react-helmet";
import LoadingSpinner from "../../components/LoadingSpinner";
import SSOAuthorizationButtons from "../../components/SSOAuthorizationButtons";
import {Divider} from "antd";

export default class AuthLogin extends FormPage {
    // Login form class
    static BGClass = 'login-form [&>.form-container]:py-0';

    // The nav path for this view
    static path = '/login';

    /**
     * The title shown on the form
     */
    static FormTitle = "auth.login.title";

    /**
     * The subtitle shown on the form
     */
    static FormSubtitle = "";

    /**
     * The submit button title for the form
     */
    static FormSubmit = "auth.login.submit_button";

    /**
     * The config for the optional footer
     *
     * @var {Object}
     */
    static ShowFooter = false;

    /**
     * The fields mapping for the form
     */
    static FormFields = {
        email: {
            type: 'email',
            label: 'auth.login.email_label',
            autoComplete: 'email'
        },
        password: {
            type: 'password',
            label: 'auth.login.password_label',
        },
        // remember_me: {
        //     type: 'checkbox',
        //     label: 'auth.login.remember_label',
        //     required: false
        // },
    };

    /**
     * The links mapping for the form
     */
    static FormLinks = [
        {
            path: '/password/forgot',
            title: 'auth.login.password_help_link',
        }
    ];

    componentDidMount() {
        super.componentDidMount();
        if (laravel.oauth_error === 'No user found') {

            TB.alert('error',
                'No user found.',
                'There was an error while trying to authenticate you. ' +
                'There was no account found matching your SSO Provider. Please try again or contact your administrator for assistance.',
                [{title: 'Ok'}]);
            laravel.oauth_error = null;
        }
    }

    /**
     * Whether or not an alert should show if the user tries to navigate to another page or close the browser
     *
     * @var {Boolean}
     */
    static ShowsUnloadWarning = false;

    /**
     * The max width in pixels for the form container
     *
     * @var {Integer}
     */
    static MaxWidth = 800;

    /**
    * Handles form submit button clicks when form is valid
    *
    * @param {Object} creds
    * @returns void
    */
    async onSubmit(creds) {
        // TB.log().object(
        // 	'Login @ onSubmit', { ...creds }
        // );
        let isDisabled = true;
        await this.promisedState({ isDisabled });
        try {
            let user = await Auth.login(creds);
            isDisabled = false;
        } catch (e) {
            console.warn(e)
            isDisabled = false;
        }

        return this.promisedState({ isDisabled })
    }


    /**
     * Overridable method for rendering any form child elements
     *
     * @returns {Component}
     */

    renderFormView() {
        const logoDisplayClass = laravel.platform_settings.Show_Logo_On_Login_Page === true ? '' : 'hidden';

        return (
            <>
                <Helmet>
                    <title>Login | Wripple</title>
                </Helmet>
                <div className="mt-16 mb-20 px-4 py-16 m-auto bg-white sm:px-14 md:w-10/12 xl:w-9/12 ">
                    <div className="items-center lg:flex">
                        <div className="px-4 lg:w-1/2">
                            <div className="flex items-center flex-col lg:mb-5">
                                <h6 className="text-xs md:text-base">welcome to</h6>
                                <Img
                                    loader={(
                                        <div className={`flex flex-col items-center justify-center ${logoDisplayClass}`}>
                                            <LoadingSpinner />
                                        </div>
                                    )}
                                    src={[TB.logoBrandImagePath(), '/images/logo.png']}
                                    className={`w-36 md:w-48 ${logoDisplayClass}`}
                                />
                            </div>
                            <div className="w-full m-auto hidden md:block">
                                <img
                                    className="w-full px-12"
                                    src={laravel.platform_settings.Asset_Login_Graphic} alt={`Welcome to ${laravel.platform_name}`}
                                />
                            </div>
                        </div>

                        <div className="px-4 lg:w-1/2">


                            {this.renderForm()}
                            <Divider plain className="my-2">Or continue with:</Divider>

                            <div className="mb-3 flex flex-row items-center justify-center gap-3">
                                <SSOAuthorizationButtons/>
                            </div>

                        </div>
                    </div>
                </div>
            </>

        );
    }
}